import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HelpNewComponent } from './help.component';

const routes: Routes = [{ path: '', component: HelpNewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HelpTestRoutingModule { }
